import React from 'react';
import FYNTRAC_MARK from '../../assets/fyntrac-mark.png';

/**
 * The Fyntrac "Fyn" mark centred on its navy disc — the Fyntrac roundel.
 * Same artwork and proportions as the roundel in fyntrac-dsl, so the AI
 * launcher and the chat drawer header read as one brand element.
 */
export default function FyntracMark({ size = 26, style }) {
  return (
    <span
      aria-hidden="true"
      style={{
        width: size, height: size, flexShrink: 0, borderRadius: '50%',
        background: '#14213D', display: 'inline-grid', placeItems: 'center',
        overflow: 'hidden', boxShadow: '0 1px 3px rgba(20,33,61,0.22)',
        ...style,
      }}
    >
      <img src={FYNTRAC_MARK} alt="" style={{ width: Math.round(size * 0.64), display: 'block' }} />
    </span>
  );
}

export { FYNTRAC_MARK };
